exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".mat-expansion-panel-body {\n  padding: 0px !important; }\n\n.badge {\n  float: right; }\n\n@-moz-document url-prefix() {\n  .pure-checkbox input[type=\"checkbox\"] {\n    position: absolute !important; } }\n\n@media only screen and (max-width: 600px) {\n  .check_box {\n    display: block !important; } }\n\n.product_description {\n  min-width: 230px; }\n\n.make_width {\n  min-width: 230px; }\n\n.model_width {\n  min-width: 230px; }\n\n.additional_field1_width {\n  min-width: 230px; }\n\n.additional_field2_width {\n  min-width: 230px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /codebuild/output/src3074433461/src/src/app/generic-ui-components/generic-accordion-items/generic-accordion-items.component.scss
// module id = ../../../../../src/app/generic-ui-components/generic-accordion-items/generic-accordion-items.component.scss
// module chunks = main